module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (10).a7842f03.svg";